import React from 'react';
import { Domingo } from '@fiverr-private/domingo';
import { Button } from '@fiverr-private/button';
import { I18n } from '@fiverr-private/i18n-react';
import { useImpressionItem } from '@fiverr-private/impressionable';
import { Container, Grid, GridItem, Stack } from '@fiverr-private/layout_components';
import { FiverrProLogo, CheckStarSolidIcon } from '@fiverr-private/visuals';
import { Box } from '@fiverr-private/theme';
import { Heading, Text, Typography } from '@fiverr-private/typography';
import { getContext } from '@fiverr-private/fiverr_context';
import {
    BQ_CLICKED_HOMEPAGE_LO_BUSINESS_SERVICES,
    BQ_IMP_FIP_IS_SHOWN,
} from '../../utils/biEvents/events/bigQueryEvents';
import { getImpressionEnrichment, sendBigQueryEvent, sendMixPanelEvent } from '../../utils/biEvents';
import { MP_FIB_CLICK } from '../../utils/biEvents/events/mixPanelEvents';
import { imgSrc, pictureData, copyData } from './config';
import { imageCustomClass, titleCustomClass, titleEmCustomClass } from './styles.ve.css';

export const reportBi = () => {
    sendBigQueryEvent({ eventName: BQ_CLICKED_HOMEPAGE_LO_BUSINESS_SERVICES });
    sendMixPanelEvent({ eventName: MP_FIB_CLICK });
};

const ProPackagesBannerA = () => {
    const { url } = getContext();
    const proUrl = `${Domingo(url).removePath().pro().url}?source=LOHP_business_banner`;

    const [ref] = useImpressionItem(getImpressionEnrichment({ eventName: BQ_IMP_FIP_IS_SHOWN }));

    return (
        <Container
            data-testid="pro-packages-banner-a"
            backgroundColor="green_100"
            paddingX={{ default: '6', md: '12', lg: '20' }}
            paddingY={{ default: '8', md: '10', lg: '14' }}
            paddingRight={{ default: '6', md: '12', lg: '8' }}
            borderRadius="2xl"
            ref={ref}
        >
            <Grid templateColumns="15_cols" rowGap="16">
                <GridItem columnStart="1" columnEnd={{ default: '16', lg: '8' }}>
                    <Container marginBottom={{ default: '7', lg: '8' }}>
                        <FiverrProLogo />
                    </Container>
                    <Typography
                        as="h2"
                        fontWeight="normal"
                        size={{ default: 'h_xl', lg: 'h_3xl' }}
                        color="grey_1200"
                        marginBottom={{ default: '10', lg: '8' }}
                        className={titleCustomClass}
                    >
                        <I18n
                            k="logged_out_homepage.business.title"
                            templates={{
                                em: (text) => (
                                    <Box
                                        as="em"
                                        color="green_700"
                                        fontFamily="domaine"
                                        fontStyle="normal"
                                        className={titleEmCustomClass}
                                    >
                                        {text}
                                    </Box>
                                ),
                            }}
                        />
                    </Typography>
                    <Grid
                        templateColumns={{ default: '100%', md: '50%_50%' }}
                        columnGap={{ default: '6', md: '5' }}
                        rowGap={{ default: '6', md: '5' }}
                        marginBottom={{ default: '10' }}
                    >
                        {copyData.list.map(({ title, content }) => (
                            <GridItem key={title}>
                                <Stack
                                    alignItems={{ default: 'center', md: 'flexStart' }}
                                    direction={{ default: 'row', md: 'column' }}
                                >
                                    <CheckStarSolidIcon color="green_1200" size="md" />
                                    <Heading as="h6">
                                        <I18n k={title} />
                                    </Heading>
                                </Stack>
                                <Text size={{ default: 'b_md', md: 'b_sm' }}>
                                    <I18n k={content} />
                                </Text>
                            </GridItem>
                        ))}
                    </Grid>
                    <Stack justifyContent={{ default: 'center', md: 'flexStart' }}>
                        <Button href={proUrl} size="lg" target="_blank" onClick={reportBi}>
                            <I18n k={copyData.cta} />
                        </Button>
                    </Stack>
                </GridItem>
                <GridItem
                    columnStart={{ default: '1', lg: '8' }}
                    columnEnd={{ default: '16', lg: '16' }}
                    display={{ default: 'none', lg: 'flex' }}
                    justifyContent="center"
                    alignItems="center"
                >
                    <picture>
                        {pictureData.map((image) => (
                            <source
                                key={String(image.media + image.srcSet)}
                                media={image.media}
                                srcSet={image.srcSet}
                            />
                        ))}
                        <img src={imgSrc} loading="lazy" alt={copyData.alt} className={imageCustomClass} />
                    </picture>
                </GridItem>
            </Grid>
        </Container>
    );
};

export default ProPackagesBannerA;
